/** Shared pill button styles for wallet / subscription balance cards. */
export const balanceCardButtonClassName =
  'h-[45px] min-w-[179px] rounded-[40px] px-5 py-3 bg-white shadow-[0px_4px_14px_0px_rgba(0,0,0,0.1)] !text-royalBlue !border-0 font-poppins font-semibold text-sm leading-none';

export const formatCurrencyAmount = (amount: number) =>
  amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Wallet balance tile — desktop + mobile. */
export const balancePromoCardSurfaceClassName = `md:bg-[url("https://open-rewards-prod.s3.us-west-2.amazonaws.com/media/public/business_portal_images/Wallet+Balance+BG.png")] bg-[url("https://open-rewards-prod.s3.us-west-2.amazonaws.com/media/public/business_portal_images/MobWalletBalanceBG.jpg")] bg-cover bg-no-repeat bg-royalBlue rounded-[26px] mb-2 flex md:flex-row flex-col md:items-center justify-between py-10 px-7 gap-5 w-full h-[200px]`;

/** Subscription revenue tile — outer shell (main body + footer). */
export const subscriptionRevenueCardClassName =
  'rounded-[26px] overflow-hidden mb-2 flex flex-col w-full h-[200px] border border-darkGreyBlue bg-navyDark box-border';

/** Subscription revenue tile — main body with background texture. */
export const subscriptionRevenueCardBodyClassName = `min-h-0 flex-1 flex flex-col md:bg-[url("https://open-rewards-prod.s3.us-west-2.amazonaws.com/media/public/business_portal_images/Subscription+Wallet+Balance+BG+-+Large.png")] bg-[url("https://open-rewards-prod.s3.us-west-2.amazonaws.com/media/public/business_portal_images/Subscription+Wallet+Balance+BG+-+Small.jpg")] bg-cover bg-no-repeat px-7 py-3`;

/** Subscription revenue tile — divider between body and footer. */
export const subscriptionRevenueCardDividerClassName = 'h-px shrink-0 bg-darkGreyBlue';

/** Subscription revenue tile — 40px footer strip. */
export const subscriptionRevenueCardFooterClassName =
  'flex h-10 shrink-0 items-center bg-offWhite px-7';
